var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6723 14.7964C19.6598 12.5023 20.6975 10.7707 22.7979 9.49548C21.6227 7.81392 19.8474 6.88875 17.5032 6.70747C15.284 6.53244 12.8586 8.00146 11.9709 8.00146C11.0333 8.00146 8.88287 6.76998 7.19506 6.76998C3.70693 6.82624 0 9.55174 0 15.0965C0 16.7343 0.300055 18.4263 0.900164 20.1724C1.70031 22.4666 4.58834 28.0926 7.60138 27.9988C9.17667 27.9613 10.2894 26.8799 12.3397 26.8799C14.3276 26.8799 15.359 27.9988 17.1156 27.9988C20.1537 27.9551 22.7666 22.8417 23.5293 20.5412C19.4535 18.6221 19.6723 14.9152 19.6723 14.7964ZM16.1342 4.53207C17.8407 2.50671 17.6845 0.662621 17.6345 0C16.1279 0.0875159 14.3839 1.02519 13.3899 2.18165C12.296 3.41937 11.6521 4.9509 11.7896 6.67621C13.4212 6.80124 14.909 5.96358 16.1342 4.53207Z",
    fill: "#585A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.ce267773788d4433f1c561b3f1bfb22e.svg";
export { ForwardRef as ReactComponent };